import { render, staticRenderFns } from "./EduCourseOrder.vue?vue&type=template&id=340c2bc5&scoped=true&"
import script from "./EduCourseOrder.vue?vue&type=script&lang=js&"
export * from "./EduCourseOrder.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseOrder.vue?vue&type=style&index=0&id=340c2bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c2bc5",
  null
  
)

export default component.exports